module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "EQPage_content"
  }, [_c('div', {
    staticClass: "EQPage_content_head"
  }, [_c('div', {
    staticClass: "EQPage_head_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.EQPageImg
    },
    on: {
      "error": function($event) {
        return _vm.changeToDefaultImg(1)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "EQPage_content_body"
  }, [_c('div', {
    staticClass: "EQPage_content_body_title"
  }, [_vm._v(_vm._s(_vm.topicOrCourseName))]), _vm._v(" "), _c('div', {
    staticClass: "EQPage_content_body_host"
  }, [_c('img', {
    staticClass: "EQPage_content_body_img",
    attrs: {
      "src": _vm.userPhoto,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.changeToDefaultImg(2)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "EQPage_content_body_hostName"
  }, [_vm._v(_vm._s(_vm.hostName))])]), _vm._v(" "), (_vm.type === 'topic') ? _c('div', {
    staticClass: "EQPage_content_body_topic"
  }, [_c('div', {
    staticClass: "EQPage_content_body_topic_time"
  }, [_c('span', [_vm._v("会议时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.topicData.startDateStr))])]), _vm._v(" "), _c('div', {
    staticClass: "EQPage_content_body_topic_useTime"
  }, [_c('span', [_vm._v("预计用时：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.topicData.timeCount) + "小时")])])]) : _c('div', {
    staticClass: "EQPage_content_body_course"
  }, [_c('div', {
    staticClass: "EQPage_content_body_course_time"
  }, [_c('span', {
    staticClass: "text_left"
  }, [_vm._v("课程时间：")]), _vm._v(" "), _c('span', {
    staticClass: "text_right"
  }, [_vm._v(_vm._s(_vm.courseData.courseTimeStr))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "EQPage_content_body_course_detail"
  }, [_c('span', {
    staticClass: "text_left"
  }, [_vm._v("课程简介：")]), _vm._v(" "), _c('span', {
    staticClass: "text_right",
    staticStyle: {
      "overflow-y": "auto",
      "height": "90%"
    }
  }, [_vm._v(_vm._s(_vm.courseData.remark))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])]), _vm._v(" "), (_vm.isShowFoot) ? _c('div', {
    staticClass: "EQPage_content_foot"
  }, [_c('div', {
    staticClass: "EQPage_content_foot_main"
  }, [_c('div', {
    staticClass: "EQPage_content_foot_status"
  }, [_vm._v(_vm._s(_vm.tipValue))]), _vm._v(" "), (_vm.isShowCountDown) ? _c('div', {
    staticClass: "EQPage_content_foot_countdown"
  }, [_c('countdown', {
    attrs: {
      "secTime": _vm.secTime
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "EQPage_content_foot_button",
    on: {
      "click": _vm.clickBotton
    }
  }, [_vm._v(_vm._s(_vm.buttonValue))])])]) : _vm._e(), _vm._v(" "), _c('pops', {
    attrs: {
      "show": _vm.isShowVideoList,
      "title": '回放视频列表',
      "width": '90%'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [(_vm.videoList.length > 0) ? _c('div', {
    staticClass: "videoList_main"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.url,
      staticClass: "videoList_button",
      on: {
        "click": function($event) {
          return _vm.videoClick(item)
        }
      }
    }, [_vm._v("Video" + _vm._s(index + 1))])
  }), 0) : _c('div', {
    staticClass: "videoList_main"
  }, [_vm._v("\n        暂无视频\n      ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6a247fb7","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/Login/EQPage.vue
// module id = 578
// module chunks = 1 2 3 4 5 6 7 8